import { render } from "./PiagamAudit.vue?vue&type=template&id=641493e8"
import script from "./PiagamAudit.vue?vue&type=script&lang=js"
export * from "./PiagamAudit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__